import React, { forwardRef } from 'react';
import './DailySummaryShareCard.css';
import { type GameId } from '@games-monorepo/shared-utils';

export interface SummaryGameData {
    id: GameId;
    name: string;
    icon: string;
    score: string | null;
}

interface DailySummaryShareCardProps {
    date: string; // e.g. "Jan 22"
    theme: string; // 'state' or 'yikyak' etc. for branding text if needed
    games: SummaryGameData[];
}

export const DailySummaryShareCard = forwardRef<HTMLDivElement, DailySummaryShareCardProps>(
    ({ date, theme, games }, ref) => {
        const brandName = theme === 'yikyak' ? 'Yik Yak' : 'Sidechat';
        // TODO: Filter out unplayed games or shoe "Not Played"
        return (
            <div className="daily-summary-card" ref={ref}>
                <div className="daily-summary-header">
                    <div className="daily-summary-date">{date}</div>
                    <div className="daily-summary-brand">{brandName} Games</div>
                </div>

                <div className="daily-summary-grid">
                    {games.map((game) => {
                        const isPlayed = !!game.score;
                        return (
                            <div key={game.id} className="summary-game-item">
                                <img src={game.icon} alt="" className="summary-game-icon" />
                                <div className="summary-game-info">
                                    <div className="summary-game-name">{game.name}</div>
                                    <div className={`summary-game-score ${isPlayed ? 'completed' : ''}`}>
                                        {isPlayed ? (
                                            <>
                                                <span>✅</span>
                                                <span>{game.score}</span>
                                            </>
                                        ) : (
                                            <span style={{ opacity: 0.3, fontSize: '0.9em' }}>Not played</span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div className="daily-summary-footer">
                    <div className="daily-summary-link">
                         {theme === 'yikyak' ? 'yikyak.com/games' : 'sidechat.lol/games'}
                    </div>
                </div>
            </div>
        );
    }
);

DailySummaryShareCard.displayName = 'DailySummaryShareCard';
